export class EnvironmentUtils {
  public static isMobile(): boolean {
    return window.matchMedia("(max-width: 1264px)").matches;
  }

  public static execOnNextTick(func: () => void) {
    setTimeout(func, 0);
  }
}
